import React, { useEffect } from 'react';

const CustomerLogin = () => {
  useEffect(() => {
    window.open('https://naas.sarvantanet.com', '_blank');
  }, []);

  return (
    <div style={{ backgroundColor: '#000503', color: '#fff', minHeight: '100vh', padding: '60px 40px', textAlign: 'center' }}>
      <div style={{ maxWidth: '600px', margin: '0 auto', paddingTop: '80px' }}>
        <h1 style={{ fontSize: '2rem', marginBottom: '16px' }}>Customer Portal</h1>
        <p style={{ color: '#a0aec0', lineHeight: '1.8', marginBottom: '24px' }}>
          The customer portal should have opened in a new tab. If it didn't, click the button below.
        </p>
        <a
          href="https://naas.sarvantanet.com"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            padding: '14px 32px', backgroundColor: '#2563eb', color: '#fff',
            borderRadius: '8px', textDecoration: 'none', fontWeight: '600',
            fontSize: '1rem', display: 'inline-block'
          }}
        >
          Open Customer Portal
        </a>
      </div>
    </div>
  );
};

export default CustomerLogin;
